module.exports = __webpack_public_path__ + "static/0046-79292cdf26df3fb79b960410e9f30a7f.png";